/* eslint-disable no-bitwise */
import { getDateIso } from '../Helpers/dateTime'

// https://stackoverflow.com/a/2117523
const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0
    const value = char === 'x' ? random : (random & 0x3) | 0x8
    return value.toString(16)
  })
}

const defaultCommand = () => ({
  date: getDateIso(),
  id: generateUUID(),
})

export const newAnswer = ({ chatId, answer, question }) => ({
  ...defaultCommand(),
  type: 'NEW_ANSWER',
  chatId,
  answer,
  question,
})

export const newMessage = ({ chatId, body, participant }) => ({
  ...defaultCommand(),
  type: 'NEW_MESSAGE',
  chatId,
  body,
  participant,
})

export const newChatRequest = ({ brand, department }) => ({
  ...defaultCommand(),
  type: 'NEW_CHAT_REQUEST',
  brand,
  department,
})

export const renewChatRequest = ({ chatId, authenticationKey }) => ({
  ...defaultCommand(),
  type: 'RENEW_CHAT_REQUEST',
  chatId,
  authenticationKey,
})

export const sendEndStage = ({ chatId, stage }) => ({
  ...defaultCommand(),
  type: 'END_STAGE',
  chatId,
  stage,
})

export const isTyping = ({ chatId, participant }) => ({
  ...defaultCommand(),
  type: 'IS_TYPING',
  chatId,
  participant,
})

export const ping = ({ chatId }) => ({
  ...defaultCommand(),
  type: 'PING',
  chatId,
})

export default {
  isTyping,
  newAnswer,
  newChatRequest,
  newMessage,
  ping,
  renewChatRequest,
  sendEndStage,
}
